/**
 * A vendég által megnyitható útvonalak. Szándékosan felsorolás és nem tiltólista:
 * ugyanaz az elv, mint a szerveroldali írásvédelemnél - ami nincs itt, az zárva
 * van, tehát egy később hozzáadott oldal sem nyílik meg neki véletlenül.
 */
export const GUEST_ALLOWED_PATHS = ['/', '/calendar', '/bookings', '/board', '/profile', '/help', '/features'];

/**
 * Megnyithatja-e a vendég ezt az útvonalat. A prefix-egyezés csak teljes
 * útvonalszegmensre igaz, hogy egy "/boardgames" nevű oldal ne csússzon be a
 * "/board" mögé.
 */
export const isAllowedForGuest = (pathname: string): boolean => {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;

  return GUEST_ALLOWED_PATHS.some(
    (allowed) => path === allowed || (allowed !== '/' && path.startsWith(`${allowed}/`))
  );
};
